import React, { useState } from "react";
import classes from "./PayoutMethodsMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { useHistory } from "react-router-dom";
import {
  Arrowlinkicon,
  cancelIcon,
  SettingsMasterCard,
  Visa,
  Threedots,
  Payment,
} from "../../../../../constant/imagePath";
import { Button } from "../../../../../stories/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import AddPayoutMethod from "../../../../../components/Modals/CoachFlow/OnBoarding/AddPayoutMethod/AddPayoutMethod";
import { RemovePayoutMethodModal } from "../../../../../components/Modals/CoachFlow/Settings/RemovePayoutMethod/RemovePayoutMethod";
import PaymentMethodCard from "../../../../../stories/PaymentMethodCard/PaymentMethodCard";

const PayoutMethodsMobile = () => {
  const history = useHistory();
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const dispatch = useDispatch();

  const [isRemoving, setIsRemoving] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  const paymentarray = [
    {
      type: "master",
      title: "Master Card",
      number: ".... 3679",
      description: "This is your default payment method",
    },
    {
      type: "visa",
      title: "Visa Card",
      number: ".... 6543",
      description: "",
    },
  ];
  const convertedActiveTab = activeTab?.includes("-")
    ? activeTab.split("-")[0] + " " + activeTab.split("-")[1]
    : activeTab;
  return (
    <div className={[classes.PayoutMethodsScreen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Profile Settings
        </p>
      </div>
      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0"].join(" ")}>
          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Tabs
              tabsData={[
                { label: "Privacy settings", activeText: "privacy-settings" },
                { label: "Payout methods", activeText: "payout-methods" },
                { label: "Notifications", activeText: "notifications" },
              ]}
              state={{ label: convertedActiveTab }}
              setState={(item) => dispatch(setActiveTab(item?.activeText))}
            />
          </Col>

          <Col md={12}>
            <Row className={["g-0", classes.paymentCards].join(" ")}>
              {paymentarray.map((item, i) => {
                return (
                  <Col md={12} key={i}>
                    <PaymentMethodCard
                      data={item}
                      onRemove={() => setIsRemoving(true)}
                    />
                  </Col>
                );
              })}
            </Row>
          </Col>
          <Col sm={12} className={[classes.mt8, classes.mb32].join(" ")}>
            <Button
              primary={true}
              size="Large"
              customStyle={{ width: "100%" }}
              onClick={() => setIsAdding(true)}
            >
              Add new payment method
            </Button>
          </Col>

          <Col sm={12} className={[classes.mb16].join(" ")}>
            <div className={[classes.paylayoutdiv].join(" ")}>
              <img
                src={Payment}
                alt="..."
                className={[classes.paymentimg, classes.mb24].join(" ")}
              />
              <h5
                style={{
                  ...Fonts.h5,
                  color: Colors.neutralShadesOfNero,
                  fontSize: "19px",
                  lineHeight: "24px",
                }}
                className={[classes.mb8].join(" ")}
              >
                Make all payouts
                <br />
                through Lytesnap
              </h5>
              <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
                Always get paid and communicate through Lytesnap to ensure
                you're protected under our{" "}
                <span
                  style={{ color: Colors.mainBlue }}
                  className={[classes.pointer].join(" ")}
                >
                  Terms of Service
                </span>
                , cancellation, and other safeguards.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <AddPayoutMethod show={isAdding} setShow={setIsAdding} />
      <RemovePayoutMethodModal show={isRemoving} setShow={setIsRemoving} />
    </div>
  );
};
export default PayoutMethodsMobile;

{
  /* <div
className={[
  classes.dflex,
  classes.contentbetween,
  classes.paymentcard,
  classes.itemscenter,
  classes.mb8,
].join(" ")}
style={{
  height: `${item?.description ? "76px" : "72px"}`,
}}
>
<div
  className={[classes.dflex, classes.itemscenter].join(" ")}
>
  <img
    src={item?.img}
    className={[classes.mr16, classes.mastercardimg].join(
      " "
    )}
    alt="..."
  />
  <div>
    <p
      style={{
        ...Fonts.p2,
        color: Colors.neutralShadesOfNero,
      }}
      className={[classes.mb4].join(" ")}
    >
      {item?.title} {item?.number}
    </p>
    <p
      style={{
        ...Fonts.p2,
        color: Colors.neutralShadesOfDimGray,
        fontSize: "12px",
        lineHeight: "16px",
      }}
    >
      {item?.description}
    </p>
  </div>
</div>
<div>
  <img
    src={Threedots}
    className={[classes.dotsimg].join(" ")}
    alt="..."
  />
</div>
</div> */
}
